<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll scroll-container noScroll">
            <div class="suggestion-cover scroll-container">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/sugguest_banner.jpg">
            </div>
            <div class="suggestion-content suggestion-title scroll-container">{{suggestionCategory.welcomeText}}</div>
            <div class="suggestion-content suggestion-select-category scroll-container" @click="showSuggestionCategories">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/suggest_category.png" class="suggestion_icon">
                <span class="suggestion-select-text">{{suggestion.categoryName ? suggestion.categoryName : '选择意见建议类型'}}</span>
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_enter.png" class="arrow_enter">
            </div>
            <div class="suggestion-content sugestion-text scroll-container">
                <textarea class="suggestion-textarea" placeholder="具体描述 (不少于10个字)" maxlength="140" v-model="suggestion.content"></textarea>
                <span class="suggestion-number">{{suggestion.content.length}}/140</span>
            </div>
            <div class="suggestion_button js-submitBtn scroll-container" @click="submitSuggestion(suggestion)">提交建议</div>
        </div>

        <SuggestionCategory
                :isShow="isShowCategory"
                :categoryList="suggestionCategory.suggestionCategories"
                @on-close="closeCategory"
                @on-select="selectCategory"></SuggestionCategory>
    </div>
</template>

<script>
    import api from '@/api'
    import SuggestionCategory from '@/components/SuggestionCategory'
    export default {
        name: 'Suggestion',
        components: {
            SuggestionCategory
        },
        data () {
            return {
                userToken: '',
                suggestionCategory: {},
                suggestion: {
                    userName: '',
                    content: '',
                    categoryName: '',
                    categoryId: ''
                },
                isShowCategory: false
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '意见建议')
            this.$store.dispatch('HIDE_HEADER_BAR', {isHideFooter: true})
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                if (!userToken && userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                this.userToken = userToken

                this.suggestionCategory = await this.getSuggestionCategory(userToken)
            },
            async getSuggestionCategory (userToken) {
                const {success, data, errMsg} = await api.user.getSuggestionCategory(userToken)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            async submitSuggestion (suggestion) {
                if (!suggestion.content) {
                    this.$alert.show('请输入意见建议')
                    return false
                }
                if (!suggestion.categoryName) {
                    this.$alert.show('请选择意见建议类型')
                    return false
                }
                if (suggestion.content.length < 9) {
                    this.$alert.show('请输入至少10字')
                    return false
                }
                const {success, data, errMsg} = await api.user.submitSuggestion(suggestion)
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    this.$alert.show(data)
                    for (let prop in this.suggestion) {
                        this.suggestion[prop] = ''
                    }
                }
            },
            showSuggestionCategories () {
                this.isShowCategory = true
            },
            closeCategory () {
                this.isShowCategory = false
            },
            selectCategory (category) {
                this.isShowCategory = false
                this.suggestion.categoryName = category.name
                this.suggestion.categoryId = category.id
            }
        }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
        padding-top: 50px;
    }

    /****==== 意见反馈页面 ====****/
    img {
        width: 100%;
    }

    .footer-nav {
        display: none;
    }

    .page-content {
        background-color: #f0f0f0;
    }

    .suggestion-cover {
        position: relative;
        width: 100%;
        margin-top: -50px;
        overflow: hidden;
    }

    .suggestion-cover img{
        border-radius: 100% 100% 100% 100% / 0% 0% 20% 20%;
    }

    .suggestion-content {
        position: relative;
        width: 335px;
        background: #FFFFFF;
        border-radius: 5px;
        border-radius: 5px;
        margin-left: auto;
        margin-right: auto;
    }

    .suggestion-title {

        font-family: PingFang-SC-Medium;
        font-size: 12px;
        color: #333333;
        padding: 20px;
        line-height: 20px;
        margin: -50px auto 0px auto;
    }

    .suggestion-select-category {

        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #4A90E2;
        letter-spacing: 1px;
        padding: 12px 20px;
        margin: 12px auto 0px auto;
    }

    .suggestion-select-category img.suggestion_icon {
        width: 16px;
        position: relative;
        top: 3px;
        margin-right: 5px;
    }

    .suggestion-select-category .arrow_enter {
        float: right;
        width: 7px;
        position: relative;
        top: 5px;
    }

    .sugestion-text {
        padding: 15px 17px;
        height: 121.5px;
        margin-top: 11px;
    }

    .suggestion-content textarea{
        width: 100%;
        height: 100%;
        color: #000;
        font-size: 12px;
        border: none;
    }

    .suggestion-content .suggestion-number {
        position: absolute;
        font-size: 12px;
        color: #666666;
        bottom: 10.5px;
        right: 15.5px;
    }

    .suggestion_button {
        background-image: linear-gradient(270deg, #FAD961 0%, #FEBC10 100%);
        width: 100%;
        height: 48.25px;
        line-height: 48.25px;
        margin-top: 20px;
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        color: #454545;
        letter-spacing: 2.5px;
        text-align: center;
    }
</style>
